<template>
  <aside>
    <select-season :items="seasons" :select-season.sync="select_season" @change-filter="getProducts()"></select-season>
    <category-list :items="categoriesTree" :selected-items.sync="select_categories"></category-list>
<!--    <aside-banner></aside-banner>-->
  </aside>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import SelectSeason from '../../Catalog/SelectSeason'
import CategoryList from '../../Catalog/CategoryList'
// import AsideBanner from '../../Banner/AsideBanner'
export default {
  name: 'CatalogAside',
  components: {
    SelectSeason,
    CategoryList
    // AsideBanner
  },
  computed: {
    ...mapState('catalog', ['seasons', 'season', 'categoriesTree', 'categories_ids']),
    select_season: {
      get () {
        return this.season
      },
      set (val) {
        this.setSeason(val)
      }
    },
    select_categories: {
      get () {
        return this.categories_ids
      },
      set (val) {
        this.setPage(1)
        if (val.length === 0 && this.$route.query.categories) {
          this.$router.push({ query: { ...this.$route.query, categories: undefined } })
        } else {
          const value = val.join(',')
          console.log(value)
          if (value !== this.$route.query.categories) {
            this.$router.push({ query: { ...this.$route.query, categories: value, page: 1 } })
          }
        }
        // this.setCategoriesIds(val)
      }
    }
  },
  methods: {
    ...mapActions('catalog', ['getSeasons', 'getCategoriesTree', 'getSizes']),
    ...mapMutations('catalog', ['setSeason', 'setCategoriesIds', 'clearFilters', 'setPage']),
    ...mapActions('products', ['getProducts']),
    prepare () {
      this.getSeasons()
      this.getCategoriesTree()
    }
  },
  created () {
    this.prepare()
  },
  beforeDestroy () {
    this.clearFilters()
  }
}
</script>

<style scoped>

</style>
